// Overgezet uit naslag/server/imports/api/calculations/BufferTimeCalculation.ts.
import { min, round } from '../hulp.js';
import { downTimePerAsset } from './CalculationPerAsset.js';
import { runningTimePerAsset, runningTimePerRound } from './StaticCalculationData.js';
const bufferTime = (asset) => runningTimePerRound - runningTimePerAsset[asset];
export const impactPerAsset = (asset, incident, malfunction, maintenance, mechanicsKnowledge, shippingTime, specificAssetData, partsInStorage, impactBonusPresent, sparePartBonusPresent) => {
    const downTime = downTimePerAsset(asset, incident, malfunction, maintenance, mechanicsKnowledge, shippingTime, specificAssetData, partsInStorage, impactBonusPresent, sparePartBonusPresent);
    const newDownTime = downTime - bufferTime(asset);
    return newDownTime < 0 ? 0 : newDownTime;
};
/**
 * Niet in het origineel: het productieverlies van de twee vormers samen. Ze zijn redundant:
 * samen moeten ze hun draaitijd halen (2 x 18 uur) en elk kan hooguit de hele week draaien.
 * Wat de ene door stilstand niet haalt, neemt de andere over zolang die tijd heeft. Ligt er
 * een een hele week stil, dan kost dat dus niets; liggen ze allebei lang stil, dan wel.
 */
export const impactVormers = (downTimeA, downTimeB) => {
    const nodig = runningTimePerAsset.vormmachineA + runningTimePerAsset.vormmachineB;
    const beschikbaar = 2 * runningTimePerRound - downTimeA - downTimeB;
    return Math.max(0, nodig - beschikbaar);
};
export const availabilityPercentagePerAsset = (downTimeOfAsset) => {
    const number = round((1 - downTimeOfAsset / runningTimePerRound) * 100);
    return number < 0 ? 0 : number;
};
export const availabilityPercentageVm = (downTimeVmA, downTimeVmB) => {
    const vmA = availabilityPercentagePerAsset(downTimeVmA);
    const vmB = availabilityPercentagePerAsset(downTimeVmB);
    return Math.max(vmA, vmB);
};
export const availabilityFactory = (availabilityPercentages) => {
    const lowestInArray = min(availabilityPercentages) ?? 1;
    return lowestInArray / 100;
};
